import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { client } from "../data/client";
import { urlFor } from '../data/urlFor';
import { MdOpenInNew } from "react-icons/md";
import { Icon } from "@iconify/react"; // check out https://icon-sets.iconify.design/ for icon list
import '../styles/retro.scss'
import usePageTitle from '../hooks/usePageTitle';
import { GiPerspectiveDiceSixFacesFive } from "react-icons/gi";

const THEME_QUERY = `*[_type == "theme"]{
  name,
  slug,
  description,
  theme_react_icon,
  icebreaker,
  like,
  dislike,
  blocker,
  main_image,
  _createdAt
} | order(_createdAt asc)`;

function Retrospectives() {
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [randomIcebreaker, setRandomIcebreaker] = useState(null);

  usePageTitle('Retrospective Theme List | Dochano');

  useEffect(() => {
    client.fetch(THEME_QUERY)
      .then((data) => {
        setThemes(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching themes:", error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p id="Retro">Loading themes...</p>;

  const handleRandomIcebreaker = () => {
    if (themes.length === 0) return;

    // Filter themes with a non-empty icebreaker
    const validThemes = themes.filter(theme => theme.icebreaker?.trim());
    if (validThemes.length === 0) return;

    const randomTheme = validThemes[Math.floor(Math.random() * validThemes.length)];
    setRandomIcebreaker(randomTheme.icebreaker);
  };

  return (
    <section id="Retro">
      <div id="Intro">
        <h1>Retrospective Available Themes</h1>
      </div>
      
      <p>I am using Sanity.io to hold the Retrospective data used here. Embracing Agile Ceremonies has had me prepare meaningful Retrospectives for my team at the end of every two-week sprint. My teams enjoyed the variety and learning more about their co-workers with a brief Icebreaker. Having a Retrospective Theme makes the event more engaging for a development team. Note that order is by creation date.</p>
      <p>Check out <Link to="../retrotime">Retrospective Dates and Seasons</Link> to get inspired for a more timely theme.</p>

      <div style={{ marginBottom: '2rem' }}>
        <button onClick={handleRandomIcebreaker} className="random-icebreaker-button">
          <GiPerspectiveDiceSixFacesFive /> Generate Randomized Icebreaker
        </button>
        {randomIcebreaker && (
          <p className="icebreaker-display"><strong>Random Icebreaker:</strong> {randomIcebreaker}</p>
        )}
      </div>

        {themes.map((theme) => (
          <article key={theme._id}>
            <h2>{(theme.theme_react_icon && <Icon icon={theme.theme_react_icon} />)}{theme.name}</h2>
            <div className="flex">
              {theme.main_image && <img src={urlFor(theme.main_image).url()} alt={`${theme.name}`} className="mainImage" />}
              <div className="theme-text">
                {theme.description && <p className="indent">{theme.description}</p>}
                <ul>
                  <li><strong>Icebreaker:</strong> {theme.icebreaker}</li>
                  <li><strong>Like:</strong> {theme.like}</li>
                  <li><strong>Dislike:</strong> {theme.dislike}</li>
                  <li><strong>Blocker:</strong> {theme.blocker}</li>
                </ul>
                <p><Link to={`../theme/${theme.slug?.current}`}>Breakout  <MdOpenInNew /></Link></p>
              </div>
            </div>
          </article>
        ))}
    </section>
  );
}

export default Retrospectives